import { Col, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { CampoFormik } from '../../../components/CompUtils';
import es from '../../../yup-es';
import { cvTiposSelector } from '../cvSlice';
import FormikContainer from './FormikContainer';

yup.setLocale(es);

//
// ─── SCHEMA PUBLICACIONEs ────────────────────────────────────────────────
//

const PublicacionesSchema = yup.object({
  idPublicacionCv: yup.number(),
  titulo: yup.string().required(),
  idTipoPublicaciones: yup.number().required(),
  idPais: yup.number().required(),
  cantPaginas: yup.number(),
  isbn: yup.string(),
  institucionOrganizadora: yup.string().required(),
  f_presentacion: yup.date().required(),
  linkPublicacion: yup.string().url(),
  sintesis: yup.string().max(450, 'La síntesis debe tener un máximo de 450 caracteres'),
});

//
// ─── FORMULARIO PUBLICACIONES ──────────────────────────────────────────────────
//

export const FormPublicaciones = ({ formState }) => {
  const tiposPublicaciones = useSelector(cvTiposSelector).tiposPublicaciones;
  return (
    <FormikContainer
      schema={PublicacionesSchema}
      seccionKey="publicaciones"
      seccionTitle="Publicación o trabajo"
      size="lg">
      {(formik) => (
        <>
          <Form.Row>
            <Form.Group as={Col} sm={4}>
              <Form.Label for="tipoPublicacion">Tipo de publicación (obligatorio)</Form.Label>
              <Form.Control
                aria-required
                id="tipoPublicacion"
                as="select"
                name="idTipoPublicaciones"
                value={formik.values.idTipoPublicaciones}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={
                  formik.touched.idTipoPublicaciones && !!formik.errors.idTipoPublicaciones
                }>
                <option value="">Seleccione</option>
                {Object.keys(tiposPublicaciones).map((key) => {
                  const el = tiposPublicaciones[key];
                  return (
                    <option key={key} title={el.descripcion} value={el.id_tipo_publicacion}>
                      {el.nombre}
                    </option>
                  );
                })}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {formik.errors.idTipoPublicaciones}
              </Form.Control.Feedback>
            </Form.Group>
            <CampoFormik
              aria-required
              label="Título de la publicación (obligatorio)"
              col={{ sm: 8 }}
              name="titulo"
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              name="isbn"
              label="ISBN: identificador internacional de publicaciones, Ejemplo: ISBN: 978 - 950 - 0000 - 00 - 0"
              formik={formik}
              help="Link de la publicación: En caso de no poseer Link de la publicación, podrá adjuntarse en formato PDF."
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              col={{ sm: 6 }}
              label="Institución/Editorial (obligatorio)"
              name="institucionOrganizadora"
              formik={formik}
            />
            <CampoFormik
              aria-required
              type="pais"
              name="idPais"
              label="País (obligatorio)"
              col={{ sm: 6 }}
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              aria-required
              label="Fecha de presentación (obligatorio)"
              type="date"
              name="f_presentacion"
              col={{ sm: 5 }}
              formik={formik}
            />
            <CampoFormik
              style={{ width: 65 }}
              name="cantPaginas"
              label="Cant. de páginas"
              col={{ sm: 4 }}
              formik={formik}
            />
          </Form.Row>
          <Form.Row>
            <CampoFormik label="Link de la publicación" name="linkPublicacion" formik={formik} />
          </Form.Row>
          <Form.Row>
            <CampoFormik
              type="textarea"
              label="Síntesis de la temática de la publicación"
              name="sintesis"
              formik={formik}
            />
          </Form.Row>
        </>
      )}
    </FormikContainer>
  );
};
